import './PolicyPages.css';

const TermsOfUse = () => {
  return (
    <div className="policy-container" data-testid="terms-of-use">
      <div className="policy-header">
        <h1 className="policy-title">Terms of Use</h1>
        <p className="policy-subtitle">Last Updated: January 2025</p>
      </div>

      <div className="policy-content">
        <section className="policy-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using the Mediawise Solutions website and services, you accept and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our services.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. Services</h2>
          <p>
            Mediawise Solutions provides business consulting, strategy development, marketing guidance, and business systems optimization services to regional Australian businesses.
          </p>
          <p>
            Our Wise Check diagnostic tool is provided as an informational assessment. Results are indicative and should be discussed in a strategy session for full analysis and recommendations.
          </p>
        </section>

        <section className="policy-section">
          <h2>3. User Responsibilities</h2>
          <p>When using our services, you agree to:</p>
          <ul>
            <li>Provide accurate and truthful information</li>
            <li>Maintain the confidentiality of any login credentials</li>
            <li>Use our services only for lawful purposes</li>
            <li>Not attempt to interfere with the proper functioning of our website</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Intellectual Property</h2>
          <p>
            All content on this website, including text, graphics, logos, and software, is the property of Mediawise Solutions and is protected by copyright and intellectual property laws.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. Limitation of Liability</h2>
          <p>
            While we strive to provide accurate and helpful business advice, Mediawise Solutions is not liable for any business decisions made based on our recommendations. All advice should be considered in the context of your specific business circumstances.
          </p>
        </section>

        <section className="policy-section">
          <h2>6. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms of Use at any time. Changes will be posted on this page with an updated revision date.
          </p>
        </section>

        <section className="policy-section">
          <h2>7. Contact Information</h2>
          <p className="contact-info">
            <strong>Email:</strong> mitch@mediawisesolutions.com.au<br />
            <strong>Phone:</strong> 0409 265 711
          </p>
        </section>
      </div>

      <div className="policy-footer">
        <a href="/" className="back-link">← Back to Home</a>
      </div>
    </div>
  );
};

export default TermsOfUse;